export default __webpack_public_path__ + "static/media/175-rapa-nui.995fc7d1.svg";